var Primary = /** @class */ (function () {
    function Primary() {
        this.main = "#343A3F";
        this.hover = "#5F666B";
        this.focus = "#1E2429";
        this.white = "#FFFFFF";
        this.enable = "#EEEEEE";
        this.enable_strock = "#C4C6C8";
    }
    return Primary;
}());
var PrimaryNegative = /** @class */ (function () {
    function PrimaryNegative() {
        this.main = "#1E2429";
        this.hover = "#5F666B";
        this.focus = "#1E2429";
        this.white = "#FFFFFF";
        this.enable = "#343A3F";
        this.enable_strock = "#1E2429";
    }
    return PrimaryNegative;
}());
var Secondary = /** @class */ (function () {
    function Secondary() {
        this.main = "#4B9AF4";
    }
    return Secondary;
}());
var Text = /** @class */ (function () {
    function Text() {
        this.primary = "#1F2937";
        this.secondary = "#4B5563";
        this.third = "#79828E";
        this.disable = "#BDC2C8";
    }
    return Text;
}());
var TextNegative = /** @class */ (function () {
    function TextNegative() {
        this.primary = "#FFFFFF";
        this.secondary = "#BDC2C8";
        this.third = "#000000";
        this.disable = "#4B5563";
    }
    return TextNegative;
}());
var Component = /** @class */ (function () {
    function Component() {
        this.gray = "#C4C6C8";
        this.gray_01 = "#D1D1D1";
        this.gray_02 = "#E6E6E6";
        this.gray_light = "#EEEEEE";
        this.gray_dark = "#8F8F8F";
    }
    return Component;
}());
var Color = /** @class */ (function () {
    function Color() {
    }
    Color.primary = new Primary();
    Color.primaryNegative = new PrimaryNegative();
    Color.secondary = new Secondary();
    Color.text = new Text();
    Color.textNegative = new TextNegative();
    Color.component = new Component();
    return Color;
}());
/**
 * Color key, value
 */
export var ColorMap = new Map([
    ["Color.primary.main", Color.primary.main],
    ["Color.primary.enable", Color.primary.enable],
    ["Color.primary.enable_strock", Color.primary.enable_strock],
    ["Color.primary.focus", Color.primary.focus],
    ["Color.primary.hover", Color.primary.hover],
    ["Color.primary.white", Color.primary.white],
    ["Color.primaryNegative.main", Color.primaryNegative.main],
    ["Color.primaryNegative.enable", Color.primaryNegative.enable],
    ["Color.primaryNegative.enable_strock", Color.primaryNegative.enable_strock],
    ["Color.primaryNegative.focus", Color.primaryNegative.focus],
    ["Color.primaryNegative.hover", Color.primaryNegative.hover],
    ["Color.primaryNegative.white", Color.primaryNegative.white],
    ["Color.secondary.main", Color.secondary.main],
    ["Color.text.primary", Color.text.primary],
    ["Color.text.secondary", Color.text.secondary],
    ["Color.text.third", Color.text.third],
    ["Color.text.disable", Color.text.disable],
    ["Color.textNegative.primary", Color.textNegative.primary],
    ["Color.textNegative.secondary", Color.textNegative.secondary],
    ["Color.textNegative.third", Color.textNegative.third],
    ["Color.textNegative.disable", Color.textNegative.disable],
    ["Color.component.gray", Color.component.gray],
    ["Color.component.gray_01", Color.component.gray_01],
    ["Color.component.gray_02", Color.component.gray_02],
    ["Color.component.gray_light", Color.component.gray_light],
    ["Color.component.gray_dark", Color.component.gray_dark],
]);
export default Color;
